import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import HeaderBubble from './HeaderBubble';
import GreetingOverlay from './GreetingOverlay';
import AIAssistant from './AIAssistant';
import OnboardingQuestionnaire from './OnboardingQuestionnaire';
import ImpersonationBanner from './ImpersonationBanner';
import FusionTour from './FusionTour';
import { useAuth } from '../contexts/AuthContext';

const Layout = () => {
    const location = useLocation();
    const { api, user, showGreeting } = useAuth();
    const [showQuestionnaire, setShowQuestionnaire] = useState(false);
    const [questionnaireChecked, setQuestionnaireChecked] = useState(false);
    const [logoUrl, setLogoUrl] = useState(null);
    const [companyName, setCompanyName] = useState('AgencyOS');

    const isChatPage = location.pathname === '/chat';
    const isFormsPage = location.pathname === '/forms';

    useEffect(() => {
        if (!user || questionnaireChecked) return;
        
        const checkQuestionnaire = async () => {
            try {
                const [qRes, settingsRes] = await Promise.all([
                    api.get('/questionnaire/me'),
                    api.get('/system/settings').catch(() => ({ data: {} }))
                ]);
                if (!qRes.data?.completed && !['chef', 'influencer', 'freelancer'].includes(user.role)) {
                    setShowQuestionnaire(true);
                }
                const s = settingsRes.data || {};
                if (s.logo_url) {
                    setLogoUrl(s.logo_url);
                }
                setCompanyName(s.company_name || 'AgencyOS');
            } catch {}
            setQuestionnaireChecked(true);
        };
        checkQuestionnaire();
    }, [user, api, questionnaireChecked]);

    // Show questionnaire after greeting animation is done
    const shouldShowQuestionnaire = showQuestionnaire && !showGreeting;
    
    return (
        <div className="min-h-screen bg-background">
            <ImpersonationBanner />
            <GreetingOverlay />
            {!showGreeting && <FusionTour />}
            {shouldShowQuestionnaire && (
                <OnboardingQuestionnaire
                    onComplete={() => setShowQuestionnaire(false)}
                    onSkip={() => setShowQuestionnaire(false)}
                    logoUrl={logoUrl}
                    companyName={companyName}
                />
            )}
            <Sidebar />
            <HeaderBubble />
            {/* Add padding-top for floating header - considers safe area for iOS notch on mobile */}
            <main 
                className={`md:ml-64 ${isChatPage ? 'h-screen overflow-hidden' : 'min-h-screen overflow-y-auto'} md:pt-[72px]`}
                style={{ paddingTop: 'calc(56px + env(safe-area-inset-top))' }}
                data-testid="main-content"
            >
                <Outlet />
            </main>
            {/* Hide AI Assistant on forms page to avoid overlap with form navigation */}
            {!isFormsPage && <AIAssistant />}
        </div>
    );
};

export default Layout;
